export default "__VITE_ASSET__CppfIRKg__"